import type { BuildingsEnergyData } from '../../../services/buildingsEnergyDataService';
import { energyChartTotalsByYear } from '../../../components/charts/EnergyUseSupabase';
import type { EnergySeriesResult } from '../../../components/charts/EnergyUseSupabase';

export interface BhExperimentLegacyContext {
  physicalElecRes: Map<number, number>;
  physicalElecCom: Map<number, number>;
  physicalGasRes: Map<number, number>;
  physicalGasCom: Map<number, number>;
  ghgElecRes: Map<number, number>;
  ghgElecCom: Map<number, number>;
  ghgGasRes: Map<number, number>;
  ghgGasCom: Map<number, number>;
}

function mapFromExtrapolation(years: number[], values: (number | null)[]): Map<number, number> {
  const m = new Map<number, number>();
  years.forEach((y, i) => {
    const v = values[i];
    if (v != null && Number.isFinite(v)) m.set(y, v);
  });
  return m;
}

export function buildLegacyContextFromFetches(
  elecRes: EnergySeriesResult,
  elecCom: EnergySeriesResult,
  gasRes: EnergySeriesResult,
  gasCom: EnergySeriesResult,
  buildings: BuildingsEnergyData,
  previousClimatePlansBuildings?: BuildingsEnergyData
): BhExperimentLegacyContext {
  const legacyBuildings = previousClimatePlansBuildings ?? buildings;
  const physicalFromLegacy =
    previousClimatePlansBuildings != null
      ? {
          physicalElecRes: mapFromExtrapolation(
            legacyBuildings.electricity.residential.years,
            legacyBuildings.electricity.residential.values
          ),
          physicalElecCom: mapFromExtrapolation(
            legacyBuildings.electricity.commercial.years,
            legacyBuildings.electricity.commercial.values
          ),
        }
      : {
          physicalElecRes: energyChartTotalsByYear(elecRes.chartData),
          physicalElecCom: energyChartTotalsByYear(elecCom.chartData),
        };

  return {
    ...physicalFromLegacy,
    physicalGasRes: energyChartTotalsByYear(gasRes.chartData),
    physicalGasCom: energyChartTotalsByYear(gasCom.chartData),
    ghgElecRes: mapFromExtrapolation(
      legacyBuildings.electricity.residential.years,
      legacyBuildings.electricity.residential.values
    ),
    ghgElecCom: mapFromExtrapolation(
      legacyBuildings.electricity.commercial.years,
      legacyBuildings.electricity.commercial.values
    ),
    ghgGasRes: mapFromExtrapolation(
      buildings.naturalGas.residential.years,
      buildings.naturalGas.residential.values
    ),
    ghgGasCom: mapFromExtrapolation(
      buildings.naturalGas.commercial.years,
      buildings.naturalGas.commercial.values
    ),
  };
}

export function legacyValue(map: Map<number, number>, year: number): number | null {
  const v = map.get(year);
  return v != null && Number.isFinite(v) ? v : null;
}
